export const hydrateFormData = (data: any) => {
	return {
		referralSegment: data.segmentName
	};
};
